import {stringify as stringifyQs} from "query-string";
import axios from "~/axios";
import getConfig from "~/config";

export default async function saveSettings(settings) {
    let baseUrl = getConfig().baseUrl;

    let data = (await axios.post(`${baseUrl}/adminsettings`, settings)).data;

    return data;
}